import { ActionType } from "./action_types";

export const toggleExpandedFavoritesSidebar = () => ({
  type: ActionType.TOGGLE_EXPANDED_FAVORITES_SIDEBAR as const,
});
